import { useMemo } from 'react';
import { truncateByLength } from '@/common/helper';

export function useTruncateTooltip(text?: string | null, max = 20) {
  const safe = text ?? '';
  const showTooltip = safe.length > max;
  const displayText = useMemo(() => truncateByLength(safe, max), [safe, max]);
  return { displayText, showTooltip, fullText: safe };
}
